export const phoneNumber = "3473892028";
export const emailAddress = "ayuda@wprestamos.com";
export const twilioNumber = "3473892028";
export const publicAddress = "wprestamos.com/";
export const publicCobroAddress = "cobro.wprestamos.com/";
export const MAX_PENDING_MONTHS_ALLOWED = 2;

//Day of month an unpaid account is blocked. Copy only - the API decides and sends the
//real cutoff on every /customer/balance response. Never compare a local date against
//this: the server runs on America/Santo_Domingo and the device may not.
export const BLOCK_CUTOFF_DAY_FALLBACK = 21;

//Pay users for referrals after this amount of months
export const referralsSignUpMonths = 4;

//Free Trial Periods
export const freeTrialsMonth = 3;
